import { FC } from "react";
import { Result } from "antd";
import { useTranslation } from "react-i18next";

type NotFoundProps = {
    // Add any additional props here if needed
};

const NotFound: FC<NotFoundProps> = () => {
    const { t } = useTranslation();

    return (
        <Result
            status="404"
            title="404"
            subTitle={t('NotFound.subTitle')}
        />
    );
};
export default NotFound;
